// based on VizRenderer but for viz settings component in the registry.
// renderer should be able to also select the full or lite variant.

import { useViewMeta } from 'crm-index-visualization-core/core/hooks/useViewMeta';
import { useVizSettings } from 'crm-index-visualization-core/core/hooks/useVizSettings';
import { useVisualizationRegistry } from 'crm-index-visualization-core/core/data/VizCoreProvider';
import { useMutateVizSettings } from 'crm-index-visualization-core/core/hooks/useMutateVizSettings';
import { useCallback, useMemo } from 'react';
import { normalizeVizType } from '../model/vizSetting';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * @param param0
 * @returns
 */
export function VizSettingsRenderer({
  variant = 'full',
  pageType,
  LoadingComponent,
  ErrorComponent
}) {
  const vizRegistry = useVisualizationRegistry();
  const {
    data: viewMeta,
    error: viewMetaError
  } = useViewMeta();
  const vizType = useMemo(() => {
    const type = pageType !== null && pageType !== void 0 ? pageType : viewMeta === null || viewMeta === void 0 ? void 0 : viewMeta.currentViewVisualization;
    return type ? normalizeVizType(type) : undefined;
  }, [viewMeta, pageType]);
  const {
    data: vizSettings,
    error: vizSettingsError
  } = useVizSettings(vizType, {
    skip: !vizType
  });
  const [mutateVizSettings] = useMutateVizSettings();
  const onSettingsChange = useCallback(
  // setting type is erased by React context, so we don't have type knowledge here.
  settings => {
    return !vizSettings ? Promise.resolve() : mutateVizSettings(vizSettings.with(settings)).then(__ => {});
  }, [mutateVizSettings, vizSettings]);
  if (viewMetaError || vizSettingsError) {
    return /*#__PURE__*/_jsx(ErrorComponent, {});
  }
  if (!viewMeta || !vizSettings || !vizType) {
    return /*#__PURE__*/_jsx(LoadingComponent, {});
  }
  const registration = vizRegistry[vizType];
  const SettingsComponent = variant === 'lite' ? registration === null || registration === void 0 ? void 0 : registration.VizSettingsLiteComponent : registration === null || registration === void 0 ? void 0 : registration.VizSettingsComponent;
  if (!SettingsComponent ||
  // TODO: Solve flash of wrong viz type either with debounced settings or Suspense
  vizSettings.visualizationType !== vizType) {
    return null;
  }
  return /*#__PURE__*/_jsx(SettingsComponent, {
    settings: vizSettings.settings,
    onSettingsChange: onSettingsChange,
    viewMeta: viewMeta
  });
}